import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { FormikProps } from 'formik';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { FormField } from '../../../../global/components/form-element/form-field';
import { PerformPersonSearchContext, PersonSearchContext } from '../person-search/person-search-model';
import { handleOSCRRBlur } from '../person-search/oscrr-helpers';
import { getFormattedDate } from '../../../../global/helpers/date-helpers';
import { FormGroup } from '../../../../global/components/layout/form-group';


interface Props {
	formikProps: FormikProps<any>;
	labelSetting: LabelSettingProps;
}

export function MinimalPersonInfoFields(props: Props) {
	const { formikProps, labelSetting } = props;
	const dispatch = useDispatch();

	const personSearchKey = useContext(PersonSearchContext);
	const performPersonSearch = useContext(PerformPersonSearchContext);


	const handleBlur = (e, fieldName: string) => {
		//Handle Datepicker passing in date object
		const value = e instanceof Date ? getFormattedDate(e?.toISOString()) : e?.target?.value;

		formikProps.setFieldTouched(fieldName, true);


		if (performPersonSearch) {
			handleOSCRRBlur(dispatch, formikProps, personSearchKey, fieldName, value, true);
		}
	};

	return (
		<FormGroup>
			<FormField
				name='first_name'
				label={labelSetting.firstNameLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
				tooltip={{
					title: labelSetting.tooltipMessage,
				}}
				onBlur={(e) => {
					handleBlur(e, 'first_name');
				}}
			/>

			<FormField
				name='last_name'
				label={labelSetting.lastNameLabel}
				component='input'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
				//published={showCleric && isPersonClergy === 'Y'}
				tooltip={{
					title: labelSetting.tooltipMessage,
				}}
				onBlur={(e) => {
					handleBlur(e, 'last_name');
				}}
			/>

			<FormField
				name='date_of_birth'
				label={labelSetting.dobLabel}
				component='datePicker'
				touched={formikProps.touched}
				errors={formikProps.errors}
				required
				onBlur={(e) => {
					handleBlur(e, 'date_of_birth');
				}}
				tooltip={{
					title: labelSetting.tooltipMessage,
				}}
				autoWidth
			/>
		</FormGroup>
	);
}
